<template>
  <div class="create-newsletter">
    <div class="py-3 mx-3 d-flex border-bottom">
      <h2>
        Create a newsletter
      </h2>
      <button
        class="close ml-auto"
        @click="$modal.hide('create-newsletter')"
      >
        <icon icon="close" />
      </button>
    </div>

    <div class="p-3">
      <div class="form-group">
        <label>Newsletter Type</label>
        <multiselect
          v-model="data.newsletterType"
          :options="newsletterTypes"
          :allow-empty="false"
          :searchable="true"
          :show-labels="false"
          placeholder="Select a newsletter type"
          track-by="id"
          label="name"
          @input="(option, id) => { data.newsletterTypeId = option.id }"
        />
      </div>

      <div class="d-flex">
        <button
          :disabled="!formReady"
          class="btn btn-primary  ml-auto"
          @click="save"
        >
          Continue
          &nbsp;<icon icon="arrow-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import gateway from '@/gateway'

const defaultData = function () {
  return {
    newsletterType: null,
    newsletterTypeId: null,
    sections: [],
    sendAt: new Date(),
    alertLists: [],
  }
}

export default {
  data () {
    return {
      newsletterTypes: [],
      data: defaultData(),
    }
  },

  computed: {
    formReady () {
      return !!this.data.newsletterTypeId
    },
  },

  mounted () {
    this.getNewsletterTypes()
  },

  methods: {
    getNewsletterTypes () {
      return this.$http.get('/newsletters/types')
          .then((response) => {
            this.newsletterTypes = response.data.data
          })
    },

    async save () {
      // eslint-disable-next-line no-unused-vars
      const {newsletterType, ...data} = this.data
      const response = await gateway.post('/newsletters/drafts', data)

      this.$emit('save-success', response)
    },
  },
}
</script>

<style lang="scss">
.create-newsletter {
  overflow-y: visible !important;
}
</style>
